<template>
  <b-modal
    id="compare-doc-modal"
    class="pdf-modal"
    size="xl"
    no-close-on-esc
    no-close-on-backdrop
    no-fade
  >
    <template #modal-header>
      <div class="w-100">
        <h6>Comparing Documents</h6>
        <b-container>
          <b-row>
            <b-col>
              <span v-if="compareDocs[0].hit._source.doc_title">
                {{ displayList(compareDocs[0].hit._source.doc_title) }}
              </span>
              <span v-else-if="compareDocs[0].hit._source.doc_type">
                {{ displayList(compareDocs[0].hit._source.doc_type) }}
              </span>
              <span v-else-if="compareDocs[0].hit._source.doc_category">
                {{ displayList(compareDocs[0].hit._source.doc_category) }}
              </span>
              <a
                v-if="
                  compareDocs[0].hit._source.source_url &&
                  !(
                    compareDocs[0].hit._source.doc_type &&
                    (typeof compareDocs[0].hit._source.doc_type === 'string' ||
                      compareDocs[0].hit._source.doc_type instanceof String) &&
                    compareDocs[0].hit._source.doc_type.search(/archive/i) >= 0
                  )
                "
                :href="compareDocs[0].hit._source.source_url"
                target="_blank"
              >
                <span
                  v-b-tooltip.hover.v-light
                  class="ml-2"
                  style="cursor: pointer"
                  title="Source"
                >
                  <font-awesome-icon
                    style="color: black"
                    :icon="['fas', 'external-link-alt']"
                    size="1x"
                  />
                </span>
              </a>
              <br />
              <div class="text-muted search-result-sub-title">
                <span
                  v-if="
                    compareDocs[0].hit._source.action_date !== undefined &&
                    compareDocs[0].hit._source.action_date.length === 10
                  "
                >
                  {{
                    [compareDocs[0].hit._source.action_date, 'YYYY-MM-DD']
                      | moment('MMMM D, YYYY')
                  }}<span
                    v-if="
                      compareDocs[0].hit._source.doc_type ==
                        'Guidance Document' &&
                      compareDocs[0].hit._source.agency_name === 'FDA'
                    "
                  >
                    (Issue Date)</span
                  ><br
                /></span>
                {{ displayList(compareDocs[0].hit._source.doc_category) }}
                <span
                  v-if="
                    compareDocs[0].hit._source.doc_category !== undefined &&
                    compareDocs[0].hit._source.doc_category === 'Guidelines' &&
                    compareDocs[0].hit._source.doc_type !== undefined &&
                    compareDocs[0].hit._source.doc_type.length > 0
                  "
                >
                  -
                  {{ displayList(compareDocs[0].hit._source.doc_type) }}</span
                >
                <span
                  v-if="
                    compareDocs[0].hit._source.guidance_status !== undefined &&
                    compareDocs[0].hit._source.guidance_status.length > 0
                  "
                >
                  ({{ compareDocs[0].hit._source.guidance_status }})</span
                >
                <span
                  v-if="
                    compareDocs[0].hit._source.doc_sub_category &&
                    compareDocs[0].hit._source.doc_sub_category.length > 0
                  "
                >
                  - {{ compareDocs[0].hit._source.doc_sub_category }}
                </span>
                <b-badge
                  v-if="
                    compareDocs[0].hit._source.doc_type &&
                    (typeof compareDocs[0].hit._source.doc_type === 'string' ||
                      compareDocs[0].hit._source.doc_type instanceof String) &&
                    compareDocs[0].hit._source.doc_type.search(/archive/i) >= 0
                  "
                  style="cursor: default"
                  variant="danger"
                  class="mx-2"
                >
                  Archive
                </b-badge>
                <b-badge
                  v-if="
                    compareDocs[0].hit._source.guidance_status &&
                    compareDocs[0].hit._source.guidance_status.search(
                      /draft/i
                    ) >= 0
                  "
                  style="cursor: default"
                  variant="warning"
                  class="mx-2"
                >
                  Draft
                </b-badge>
                <br />
                {{ compareDocs[0].hit._source.agency_name }}
                <span
                  v-if="
                    compareDocs[0].hit._source.agency_division_name &&
                    compareDocs[0].hit._source.agency_division_name.length > 0
                  "
                >
                  {{
                    Array.isArray(
                      compareDocs[0].hit._source.agency_division_name
                    )
                      ? compareDocs[0].hit._source.agency_division_name.join(
                          ', '
                        )
                      : compareDocs[0].hit._source.agency_division_name
                  }}
                </span>
              </div>
              <span v-if="compareDocs[0].hit._source.products">
                <font-awesome-icon
                  :icon="['fas', 'pills']"
                  class="mx-2"
                  size="1x"
                  fixed-width
                />
                {{
                  displayList(
                    getUniqueProductNames(compareDocs[0].hit._source.products)
                  )
                }}
              </span>
            </b-col>
            <b-col>
              <span v-if="compareDocs[1].hit._source.doc_title">
                {{ displayList(compareDocs[1].hit._source.doc_title) }}
              </span>
              <span v-else-if="compareDocs[1].hit._source.doc_type">
                {{ displayList(compareDocs[1].hit._source.doc_type) }}
              </span>
              <span v-else-if="compareDocs[1].hit._source.doc_category">
                {{ displayList(compareDocs[1].hit._source.doc_category) }}
              </span>
              <a
                v-if="
                  compareDocs[1].hit._source.source_url &&
                  !(
                    compareDocs[1].hit._source.doc_type &&
                    (typeof compareDocs[1].hit._source.doc_type === 'string' ||
                      compareDocs[1].hit._source.doc_type instanceof String) &&
                    compareDocs[1].hit._source.doc_type.search(/archive/i) >= 0
                  )
                "
                :href="compareDocs[1].hit._source.source_url"
                target="_blank"
              >
                <span
                  v-b-tooltip.hover.v-light
                  class="ml-2"
                  style="cursor: pointer"
                  title="Source"
                >
                  <font-awesome-icon
                    style="color: black"
                    :icon="['fas', 'external-link-alt']"
                    size="1x"
                  />
                </span>
              </a>
              <br />
              <div class="text-muted search-result-sub-title">
                <span
                  v-if="
                    compareDocs[1].hit._source.action_date !== undefined &&
                    compareDocs[1].hit._source.action_date.length === 10
                  "
                >
                  {{
                    [compareDocs[1].hit._source.action_date, 'YYYY-MM-DD']
                      | moment('MMMM D, YYYY')
                  }}<span
                    v-if="
                      compareDocs[1].hit._source.doc_type ==
                        'Guidance Document' &&
                      compareDocs[1].hit._source.agency_name === 'FDA'
                    "
                  >
                    (Issue Date)</span
                  ><br
                /></span>
                {{ displayList(compareDocs[1].hit._source.doc_category) }}
                <span
                  v-if="
                    compareDocs[1].hit._source.doc_category !== undefined &&
                    compareDocs[1].hit._source.doc_category === 'Guidelines' &&
                    compareDocs[1].hit._source.doc_type !== undefined &&
                    compareDocs[1].hit._source.doc_type.length > 0
                  "
                >
                  -
                  {{ displayList(compareDocs[1].hit._source.doc_type) }}</span
                >
                <span
                  v-if="
                    compareDocs[1].hit._source.guidance_status !== undefined &&
                    compareDocs[1].hit._source.guidance_status.length > 0
                  "
                >
                  ({{ compareDocs[1].hit._source.guidance_status }})</span
                >
                <span
                  v-if="
                    compareDocs[1].hit._source.doc_sub_category &&
                    compareDocs[1].hit._source.doc_sub_category.length > 0
                  "
                >
                  - {{ compareDocs[1].hit._source.doc_sub_category }}
                </span>
                <b-badge
                  v-if="
                    compareDocs[1].hit._source.doc_type &&
                    (typeof compareDocs[1].hit._source.doc_type === 'string' ||
                      compareDocs[1].hit._source.doc_type instanceof String) &&
                    compareDocs[1].hit._source.doc_type.search(/archive/i) >= 0
                  "
                  style="cursor: default"
                  variant="danger"
                  class="mx-2"
                >
                  Archive
                </b-badge>
                <b-badge
                  v-if="
                    compareDocs[1].hit._source.guidance_status &&
                    compareDocs[1].hit._source.guidance_status.search(
                      /draft/i
                    ) >= 0
                  "
                  style="cursor: default"
                  variant="warning"
                  class="mx-2"
                >
                  Draft
                </b-badge>
                <br />
                {{ compareDocs[1].hit._source.agency_name }}
                <span
                  v-if="
                    compareDocs[1].hit._source.agency_division_name &&
                    compareDocs[1].hit._source.agency_division_name.length > 0
                  "
                >
                  {{
                    Array.isArray(
                      compareDocs[1].hit._source.agency_division_name
                    )
                      ? compareDocs[1].hit._source.agency_division_name.join(
                          ', '
                        )
                      : compareDocs[1].hit._source.agency_division_name
                  }}
                </span>
              </div>
              <span v-if="compareDocs[1].hit._source.products">
                <font-awesome-icon
                  :icon="['fas', 'pills']"
                  class="mx-2"
                  size="1x"
                  fixed-width
                />
                {{
                  displayList(
                    getUniqueProductNames(compareDocs[1].hit._source.products)
                  )
                }}
              </span>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <template #default>
      <div style="height: 60vh">
        <CompareDocs
          :path="`${publicPath}lib`"
          :link1="getFilePaths[0]"
          :link2="getFilePaths[1]"
          :compareDocs="compareDocs[0].hitPageNum"
          :docName="
            compareDocs[0].hit._source.doc_title
              ? compareDocs[0].hit._source.doc_title.substring(0, 240) + '...'
              : compareDocs[0].hit._source.bts_file_name.substring(0, 240) +
                '...'
          "
          :documentID="compareDocs[0].hit.fields.doc_id[0]"
        />
      </div>
    </template>
    <template #modal-footer>
      <div
        v-if="
          compareDocs[0].hit._source.guidance_topics !== undefined &&
          compareDocs[0].hit._source.guidance_topics.length > 1
        "
        class="float-left w-30"
      >
        Topics:
        {{ compareDocs[0].hit._source.guidance_topics.join(', ') }}
      </div>
      <div
        v-else-if="
          compareDocs[0].hit._source.guidance_topics !== undefined &&
          compareDocs[0].hit._source.guidance_topics.length === 1
        "
        class="float-left w-30"
      >
        Topic: {{ compareDocs[0].hit._source.guidance_topics[0] }}
      </div>
      <div v-else>
        <!-- leave blank to force empty footer -->
      </div>
    </template>
  </b-modal>
</template>

<script>
import Analytics from '@aws-amplify/analytics';
import CompareDocs from '@/components/CompareDocs.vue';
import { getUniqueProductNames } from '@/operators/searchModifiers';

export default {
  name: 'CompareDocsViewer',
  components: {
    CompareDocs,
  },
  props: {
    compareDocs: Array,
  },
  data() {
    return {
      viewer: './lib/pdfjs-2.9.359-dist/web/viewer.html',
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    getFilePaths() {
      return [
        encodeURI(
          this.getDocLinkPrefix(this.compareDocs[0].hit._source.source_name) +
            this.compareDocs[0].hit._source.bts_file_name
        ),
        encodeURI(
          this.getDocLinkPrefix(this.compareDocs[1].hit._source.source_name) +
            this.compareDocs[1].hit._source.bts_file_name
        ),
      ];
    },
  },
  created() {
    this.getUniqueProductNames = getUniqueProductNames;
  },
  mounted() {
    //show compare doc modal
    this.$bvModal.show('compare-doc-modal');
    window.addEventListener('message', this.receivePDFMsg);
  },
  methods: {
    closeModal() {
      this.$emit('closeCompareDocsModal');
    },
    displayList(list) {
      if (!list || list.length === 0) return '';
      else if (Array.isArray(list)) {
        if (list.length === 1) return list[0];
        else return list.slice(0, -1).join(', ') + ' and ' + list.slice(-1)[0];
      } else return list;
    },
    receivePDFMsg(event) {
      Analytics.record({
        name: `pdf${event.data.target}`,
        attributes: {
          doc1: this.compareDocs[0].hit._id,
          doc2: this.compareDocs[1].hit._id,
        },
      });
    },
    getDocLinkPrefix(sourceName) {
      return (
        'https://highprioritypipelinev1stack-bucket83908e77-nfink9l696lw.s3.us-east-2.amazonaws.com/' +
        sourceName +
        '/pdfs/'
      );
    },
  },
};
</script>

<style scoped>
.compare-doc-modal {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}

#download-button {
  margin-left: 20px;
}
.saving-info-text {
  color: #696969;
}
</style>
